<template>
  <section class="mt-16 d-flex flex-column align-center align-self-center flex-grow-1">
    <div class="mt-8 wrapperHeaderNoticia">
      <div class="mb-10 noticiaRedacaoHeader">
        <h4
          :style="{ color: noticia.hex_cor_hiperlink }"
          class="text-body-1"
          v-html="formattedRedacao"
        ></h4>
      </div>
      <div class="wrapperTitleNoticia">
        <h1 class="titleNoticia">{{ noticia.dsc_titulo_completo }}</h1>
      </div>
      <div class="mt-6 wrapperSubtitleNoticia">
        <p class="subtituloNoticia">{{ noticia.dsc_subtitulo }}</p>
      </div>
      <div class="mt-8 wrapperAutorAndDataNoticia">
        <div class="autorNoticia" v-html="autor"></div>
        <span class="dataNoticia font-weight-light">
          {{ noticia.dat_publicada_noticia | formatedDate }}
          {{ noticia.dat_publicada_noticia | formatedHour }}

          &bull; Atualizado há {{ updatedTime }}
        </span>
      </div>
    </div>
    <div
      class="mt-10 divider"
      style="width: 100%; min-height: 1px; background-color: #ddd"
    ></div>
    <section class="noticiaContent">
      <div v-for="(item, idx) in noticia.conteudo" :key="item.num_sequencia" class="my-8">
        <template v-if="item.dsc_estilo === 'unstyled'">
          <UnstyledText :content="item" portal="oglobo" />
        </template>
        <template v-else-if="item.dsc_estilo === 'atomic'">
          <AtomicContent :content="item" />
        </template>
        <template v-else-if="item.dsc_estilo === 'unordered-list-item'">
          <UnorderedListItem
            :textColor="noticia.hex_cor_pagina"
            :content="item"
            :isBoldText="
              idx >= 1 && patternsToApplyBoldTextPositions.some((item) => item === idx)
            "
          />
        </template>
        <template v-else-if="item.dsc_estilo === 'blockquote'">
          <BlockQuote :primaryColor="noticia.hex_cor_pagina" :content="item" />
        </template>
        <template v-else-if="item.dsc_estilo === 'header-two'">
          <HeaderContent :content="item" :portal="noticia.cod_portal" />
        </template>
      </div>
    </section>
  </section>
</template>

<script>
import UnstyledText from "@/components/Noticias/EstilosExibicao/UnstyledText.vue";
import AtomicContent from "@/components/Noticias/EstilosExibicao/AtomicContent.vue";
import UnorderedListItem from "@/components/Noticias/EstilosExibicao/UnorderedListItem.vue";
import BlockQuote from "@/components/Noticias/EstilosExibicao/BlockQuote.vue";
import HeaderContent from "@/components/Noticias/EstilosExibicao/HeaderContent.vue";
export default {
  props: {
    noticia: Object,
  },
  components: {
    UnstyledText,
    AtomicContent,
    UnorderedListItem,
    BlockQuote,
    HeaderContent,
  },
  data() {
    return {
      updatedTime: null,
      autor: null,
      boldTextStyleWordsToCheck: [
        "<b>LEIA MAIS</b>",
        "<b>LEIA MAIS",
        "<b>LEIA MAIS:</b>",
        "<b>Leia também</b>",
        "<b>Leia também",
        "<b>Leia também:</b>",
      ],
      patternsToApplyBoldTextPositions: null,
    };
  },
  computed: {
    formattedRedacao() {
      if (!this.noticia.dsc_redacao) {
        return "";
      }
      const parts = this.noticia.dsc_redacao.split(" / ");
      if (parts.length > 1) {
        const lastPart = parts.pop();
        const normalSpacedParts = parts.map(
          (p) =>
            `<span style="word-spacing: normal; color: ${this.noticia.hex_cor_hiperlink} !important">${p}</span>`
        );
        return `${normalSpacedParts.join(
          " / "
        )} / <strong style="word-spacing: normal">${lastPart}</strong>`;
      }
      return `<strong style="word-spacing: normal">${this.noticia.dsc_redacao}</strong>`;
    },
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join("h");
    },
    updatedTime(data_modificada) {
      return Math.abs(
        new Date(this.noticia.dat_publicada_noticia) - new Date(data_modificada)
      );
    },
  },
  created() {
    this.patternsToApplyBoldTextPositions = this.searchPatternsToApplyBoldText();

    //TODO: Refactor this calc and put it into a function.
    const MILLISECONDS_IN_ONE_MINUTE = 60000;
    const MILLISECONDS_IN_ONE_HOUR = 3600000;
    const MILLISECONDS_IN_ONE_DAY = 1000 * 60 * 60 * 24;
    const MILLISECONDS_IN_30_DAYS = 1000 * 60 * 60 * 24 * 30;
    const diff_in_ms = Math.abs(
      new Date() - new Date(this.noticia.dat_modificacao_noticia)
    );

    if (diff_in_ms < MILLISECONDS_IN_ONE_MINUTE) {
      this.updatedTime = `menos de um minuto`;
    } else if (
      diff_in_ms >= MILLISECONDS_IN_ONE_MINUTE &&
      diff_in_ms < MILLISECONDS_IN_ONE_HOUR
    ) {
      const time_in_minutes = Math.ceil(diff_in_ms / (1000 * 60)) - 1;
      if (time_in_minutes === 1) {
        this.updatedTime = `um minuto`; // minutes
      } else {
        this.updatedTime = `${time_in_minutes} minutos`;
      }
    } else if (
      diff_in_ms >= MILLISECONDS_IN_ONE_MINUTE &&
      diff_in_ms > MILLISECONDS_IN_ONE_HOUR &&
      diff_in_ms < MILLISECONDS_IN_ONE_DAY
    ) {
      const time_in_hours = Math.ceil(diff_in_ms / (1000 * 60 * 60)) - 1;
      if (time_in_hours === 1) {
        this.updatedTime = "uma hora";
      } else {
        this.updatedTime = `${time_in_hours} horas`; // hours
      }
    } else if (
      diff_in_ms >= MILLISECONDS_IN_ONE_MINUTE &&
      diff_in_ms > MILLISECONDS_IN_ONE_HOUR &&
      diff_in_ms >= MILLISECONDS_IN_ONE_DAY &&
      diff_in_ms < MILLISECONDS_IN_30_DAYS
    ) {
      const time_in_days = Math.ceil(diff_in_ms / (1000 * 60 * 60 * 24)) - 1;
      if (time_in_days === 1) {
        this.updatedTime = "um dia";
      } else if (time_in_days < 7 && time_in_days > 1) {
        this.updatedTime = `${time_in_days} dias`; // days
      } else {
        const weeks = Math.ceil(time_in_days / 7);
        if (weeks === 1) {
          this.updatedTime = "uma semana";
        } else {
          this.updatedTime = `${weeks} semanas`; // weeks
        }
      }
    } else if (
      diff_in_ms >= MILLISECONDS_IN_ONE_MINUTE &&
      diff_in_ms > MILLISECONDS_IN_ONE_HOUR &&
      diff_in_ms > MILLISECONDS_IN_ONE_DAY &&
      diff_in_ms >= MILLISECONDS_IN_30_DAYS
    ) {
      const time_in_months = Math.ceil(diff_in_ms / (1000 * 60 * 60 * 24 * 30));
      if (time_in_months - 1 === 1) {
        this.updatedTime = "um mês";
      } else {
        // Put date here when is more than one month
        this.updatedTime = `${time_in_months - 1} meses`; // months
      }
    }

    this.autor = this.noticia.dsc_localizacao
      ? `<b>Por ${this.noticia.dsc_autor} — ${this.noticia.dsc_localizacao}</b>`
      : ` <b>Por ${this.noticia.dsc_autor}</b>`;
  },
  methods: {
    stringHasPattern(string) {
      return this.boldTextStyleWordsToCheck.some((s) =>
        string.toLowerCase().includes(s.toLowerCase())
      );
    },
    searchPatternsToApplyBoldText() {
      // let positionsArr = [];
      const positionsArr = this.noticia.conteudo.map((item, idx) => {
        if (item.dsc_estilo === "unstyled" && this.stringHasPattern(item.dsc_texto)) {
          const offset = idx;
          let length = 0;
          let i = idx + 1;
          do {
            length += 1;
            i += 1;
          } while (
            i < this.noticia.conteudo.length &&
            this.noticia.conteudo.at(i).dsc_estilo === "unordered-list-item"
          );
          const values = Array.from({ length }, (_, i) => offset + 1 + i * 1);
          return values;
        }
      });
      return positionsArr.filter((item) => item).flat(1);
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  // position: absolute;
  width: 45%;
  height: 100vh;
  background-color: white;
}

.wrapperAutorAndDataNoticia {
  width: 60%;
}

.noticiaRedacaoHeader {
  h4 {
    font-weight: 400;
    word-spacing: 0.7rem;
  }
}

.titleNoticia {
  color: #000;
  font-weight: bold;
  font-size: 2.7rem;
  line-height: 3.6rem;
  font-family: "Times New Roman", Times, serif;
}

.subtituloNoticia {
  font-size: 1.3rem;
  color: #000000;
  font-weight: 300;
}

.autorNoticia {
  font-size: 1.1rem;
  color: #555555;
  line-height: 1.1rem;
  // font-weight: bold;
}

.dataNoticia {
  font-size: 0.8rem;
  font-weight: 400;
  color: #555555;
}

.noticiaContent {
  width: 85%;
  height: auto;
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 300px) and (max-width: 767px) {
  section {
    // position: absolute;
    width: 100%;
    height: 100vh;
    background-color: white;
  }

  .wrapperHeaderNoticia {
    width: 90%;
  }
  .wrapperTitleNoticia {
    width: 100%;
  }
  .titleNoticia {
    color: #000;
    font-weight: bold;
    font-size: 2.4rem;
    line-height: 2.8rem;
  }

  .wrapperSubtitleNoticia {
    margin: 0 !important;
    margin-top: 20px !important;
  }

  .subtituloNoticia {
    font-size: 1.3rem;
    color: #555555;
    font-weight: 500;
    line-height: 1.55rem;
  }

  .wrapperAutorAndDataNoticia {
    margin-top: 0px !important;
    width: 85%;
    height: auto;
  }
  .autorNoticia {
    font-size: 1.1rem;
    color: #555555;
    margin-bottom: 4px !important;
    // font-weight: bold;
  }

  .dataNoticia {
    margin-top: 5px;
    font-size: 1.1rem;
    font-weight: 400;
    color: #555555;
  }

  .divider {
    margin-top: 32px !important;
  }

  .noticiaContent {
    width: 80%;
    height: auto;
  }
}

// tablets
@media (min-width: 768px) and (max-width: 1023px) {
  section {
    // position: absolute;
    width: 100%;
    height: 100vh;
    background-color: white;
  }

  .wrapperHeaderNoticia {
    width: 80%;
  }
  .wrapperTitleNoticia {
    width: 95%;
  }
  .titleNoticia {
    color: #000;
    font-weight: bold;
    font-size: 3rem;
    line-height: 3rem;
  }

  .wrapperSubtitleNoticia {
    margin: 0 !important;
    margin-top: 20px !important;
  }

  .subtituloNoticia {
    font-size: 1.3rem;
    color: #555555;
    font-weight: 500;
    line-height: 1.55rem;
  }

  .wrapperAutorAndDataNoticia {
    margin-top: 0px !important;
    width: 70%;
    height: auto;
  }
  .autorNoticia {
    font-size: 1.1rem;
    color: #555555;
    margin-bottom: 4px !important;
    // font-weight: bold;
  }

  .dataNoticia {
    margin-top: 5px;
    font-size: 1.1rem;
    font-weight: 400;
    color: #555555;
  }

  .divider {
    margin-top: 32px !important;
  }

  .noticiaContent {
    width: 80%;
    height: auto;
  }
}
</style>
